var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 26,
    height: 26,
    transform: "translate(0.004 0.001)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    transform: "translate(-0.004 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M1.885,14.175a.561.561,0,0,0,.278-.206q1.3-1.3,2.593-2.6a.978.978,0,0,1,1.552,0c.582.58,1.167,1.157,1.736,1.75.182.189.292.193.48,0q2.217-2.242,4.451-4.466a.993.993,0,0,1,1.614-.012q2.2,2.2,4.4,4.4a.969.969,0,0,1-.133,1.567.989.989,0,0,1-1.226-.213q-1.41-1.407-2.815-2.819c-.27-.27-.549-.533-.806-.815-.163-.179-.273-.163-.438,0q-2.24,2.259-4.492,4.506a1.082,1.082,0,0,1-.629.368,1.019,1.019,0,0,1-.906-.321c-.595-.608-1.2-1.2-1.8-1.811-.155-.159-.256-.168-.417,0q-1.633,1.65-3.281,3.285a.522.522,0,0,0-.163.407c.007.6,0,1.2,0,1.806,0,.854.329,1.186,1.178,1.186q5.345,0,10.69,0a.938.938,0,0,1,.122,1.871c-.076,0-.153,0-.229,0q-5.418,0-10.835,0a2.727,2.727,0,0,1-2.8-2.808C.01,13.768.028,8.284,0,2.8A2.844,2.844,0,0,1,2.8,0c5.493.023,10.987.008,16.48.009A2.725,2.725,0,0,1,22.062,2.8q0,5.474,0,10.948a.923.923,0,0,1-.677.947.963.963,0,0,1-1.071-.419,1.1,1.1,0,0,1-.126-.607q0-5.274,0-10.547a2.216,2.216,0,0,0-.034-.484.872.872,0,0,0-.718-.723,1.98,1.98,0,0,0-.427-.035H3.074c-.057,0-.115,0-.172,0A.953.953,0,0,0,1.886,2.913c0,.076,0,.153,0,.229V14.175Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M221.274,217.839q0,.573,0,1.146c0,.384,0,.384.4.384.764,0,1.528,0,2.292,0a.937.937,0,1,1-.008,1.873c-.793,0-1.585.008-2.378,0-.239,0-.313.074-.31.311.012.792.006,1.585,0,2.378a.937.937,0,1,1-1.873.005c0-.774-.013-1.547.006-2.32.007-.283-.064-.384-.364-.376-.773.021-1.547.008-2.32.006a.938.938,0,1,1,.009-1.873c.793,0,1.585-.007,2.378,0,.227,0,.3-.072.295-.3-.011-.8-.006-1.6,0-2.406a.937.937,0,1,1,1.873-.006c0,.391,0,.783,0,1.175",
    transform: "translate(-199.211 -199.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M72.008,50.784a2.771,2.771,0,1,1,2.739,2.782,2.732,2.732,0,0,1-2.739-2.782m2.749.886a.9.9,0,0,0,.9-.876A.882.882,0,0,0,73.9,50.78a.9.9,0,0,0,.86.89",
    transform: "translate(-66.494 -44.346)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImage);
export default __webpack_public_path__ + "static/media/icon_add_image.e52f687ccc87f929dcfbcb31840ff266.svg";
export { ForwardRef as ReactComponent };